module.exports = __webpack_public_path__ + "static/media/alis18.87f04663.jpg";